import { net_filemanage } from "@/api/http";

export const API_STFMFM02C19_ETFPutInTrash = (...params) =>
net_filemanage.post("/api/STFMFM02C19/ETFPutInTrash", ...params);
